// @ts-nocheck
import React, { ReactNode } from "react";

const attachToLastWord = (string: string, node?: ReactNode) => {
    const split = string.trim().split(" ");
    const lastWord = split.pop();

    return (
        <>
            {split.length ? `${split.join(" ")} ` : null}
            <span style={{ whiteSpace: "nowrap" }}>
                {lastWord}
                {node}
            </span>
        </>
    );
};

export default attachToLastWord;
